import '.a{display:flex;}.ssr-plugin'
import '.ef{justify-content:flex-start;}.ssr-plugin'
import '.a8{width:100%;}.ssr-plugin'
import '.d9{max-width:100%;}.ssr-plugin'
import { useQuery } from '@based/sdk/react'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { SafeHtml } from '@app/components/core/safeHtml/SafeHtml'
import { LoaderWrapper } from '@app/components/blocks/loader/LoaderWrapper'
import { useTranslations } from '@i18n/useLanguage'
import type { ViewPlotRegistryModel } from 'functions/app/plot-registry/view'
import { CtaCard } from '@app/components/blocks/card/CtaCard'
import personWithWaterCan from '@app/assets/images/person_with_water_can.svg'
import { styled } from 'inlines'
import { PlotRegistryStepTemplate } from './PlotRegistryStepTemplate'

type ConfirmationStepProps = {
  plotRegistryId: number
}

export const ConfirmationStep = ({ plotRegistryId }: ConfirmationStepProps) => {
  const t = useTranslations().app.plotRegistry.confirmation
  const { data: rawPlotRegistry } = useQuery(
    'view-plot-registry',
    { id: plotRegistryId },
  )
  const plotRegistry = rawPlotRegistry as ViewPlotRegistryModel | undefined

  if (!plotRegistry) {
    return <LoaderWrapper loading={true} />
  }

  return (
    <PlotRegistryStepTemplate
      leftGap="1rem"
      rightGap="1.5rem"
      leftStyle={{ width: '50%' }}
      rightStyle={{ width: '50%', overflowWrap: 'break-word', wordBreak: 'break-word' }}
      left={
        <>
          <div className="a ef">
            <CtaCard
              title=''
              illustration={personWithWaterCan}
            />
          </div>
          <Text.Small
            style={{
              color: 'var(--shades-red-400)',
              fontWeight: 700,
              textTransform: 'uppercase',
            }}
          >
            {t.congratulations}
          </Text.Small>
          <Title.H2>{t.title}</Title.H2>
          <Text.Medium style={{ color: 'var(--gray-500)' }}>
            {t.subtitle}
          </Text.Medium>
        </>
      }
      right={
        plotRegistry.closingRemark ? (
          <div className="a8 d9">
            <SafeHtml html={plotRegistry.closingRemark} />
          </div>
        ) : null
      }
    />
  )
}
